import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'NewsCategory';

const NewsCategoryApi: any = baseApi(endpoint);

export default NewsCategoryApi;